import { cacheConfig, http } from '../helpers/axiosHelper';

export default class ModuleTypeService {
   async getModuleTypes() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module-type', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }
}
